/**
 * Invia i campi di un form a un'altra pagina con una POST "classica" (come $.redirect),
 * mantenendo anche i campi vuoti: $.redirect() li scarta, e i template email lascerebbero
 * i segnaposto non sostituiti.
 * @param {string} url pagina di destinazione
 * @param {HTMLFormElement} sourceForm form da cui leggere i campi
 */
export default function postFormTo(url, sourceForm) {
    const form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', url);
    form.style.display = 'none';
    for (const [name, value] of new FormData(sourceForm)) {
        if (typeof value !== 'string') continue; // nessun file
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }
    document.body.appendChild(form);
    HTMLFormElement.prototype.submit.call(form); // anche se un campo si chiama "submit"
}
